"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.offerCreator.name': 'Kreator Ofert',
    'tools.offerCreator.description': 'Wykrywa i uzupełnia informacje o ofercie/wycenie z wiadomości użytkowników, w tym szczegóły firmy, typy opodatkowania i działalność gospodarczą',
};
